<script>
export default {
    name: "PublicWidgetDonation",
    props: {
        data: Object,
    },
    created() {
        this.loadData();
    },
    computed: {
        amountCurrency() {
            return new Intl.NumberFormat().format(this.amount);
        },
    },
    data() {
        return {
            name: '',
            title: '',
            amount: 0,
            eventAmount: 0,
            allowChangeAmount: false,
            allowChangeDesignation: false,
            buttonLabel: '',
            description: '',
            panelDesign: {
                backgroundColor: '#ffffff',
                textColor: '#000000',
                amountColor: '#41b8dc',
                borderColor: '#ddd',
                borderSize: 1,
                borderRadius: 8,
            },
            buttonDesign: {
                color: '#41b8dc',
                textColor: '#ffffff',
                borderColor: '#41b8dc',
                borderSize: 1,
                borderRadius: 8,
            },
            campaign: '',
            designation: '',
        }
    },
    methods: {
        loadData() {
            this.name = this.data.name;
            this.title = this.data.title;
            this.amount = this.data.amount;
            this.eventAmount = this.data.event_amount;
            this.allowChangeAmount = this.data.allow_change_amount;
            this.allowChangeDesignation = this.data.allow_change_designation;
            this.buttonLabel = this.data.button_text;
            this.description = this.data.description;
            this.panelDesign.backgroundColor = this.data.background_color;
            this.panelDesign.textColor = this.data.text_color;
            this.panelDesign.amountColor = this.data.amount_color;
            this.panelDesign.borderColor = this.data.border_color;
            this.panelDesign.borderSize = this.data.border_size;
            this.panelDesign.borderRadius = this.data.border_radius;
            this.buttonDesign.color = this.data.button_color;
            this.buttonDesign.textColor = this.data.button_text_color;
            this.buttonDesign.borderColor = this.data.button_border_color;
            this.buttonDesign.borderSize = this.data.button_border_size;
            this.buttonDesign.borderRadius = this.data.button_border_radius;
            this.campaign = this.data.campaign_id;
            this.designation = this.data.designation_id || '';
        },
        donate() {
            // post message to parent window
            window.parent.postMessage({
                action: 'donate',
                widget: this.data,
            }, '*');
        },
    }
}
</script>

<template>
    <div
        class="c-preview"
        :style="{
          backgroundColor: panelDesign.backgroundColor,
          borderColor: panelDesign.borderColor,
          borderWidth: `${panelDesign.borderSize}px`,
          borderRadius: `${panelDesign.borderRadius}px`,
      }"
    >
        <div
            class="c-preview__title"
            :style="{
              color: panelDesign.textColor,
          }"
        >
            {{ title }}
        </div>
        <div
            class="c-preview__amount"
            :style="{
              color: panelDesign.amountColor,
          }"
        >
            ${{ amountCurrency }}
        </div>
        <div class="c-preview__description"
             :style="{
                  color: panelDesign.textColor,
              }"
        >
            {{ description }}
        </div>
        <button
            @click="donate"
            class="btn c-preview__btn"
            :style="{
                  backgroundColor: buttonDesign.color,
                  color: buttonDesign.textColor,
                  borderColor: buttonDesign.borderColor,
                  borderWidth: `${buttonDesign.borderSize}px`,
                  borderRadius: `${buttonDesign.borderRadius}px`,
              }"
            v-if="buttonLabel"
        >
            {{ buttonLabel }}
        </button>
    </div>
</template>

<style scoped lang="scss">
.c-preview {
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #ddd;
    width: 290px;
    height: 257px;
    aspect-ratio: 1;
    margin-bottom: 30px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;

    &__title {
        font-weight: 700;
        font-size: 18px;
        margin-bottom: 12px;
    }

    &__amount {
        font-size: 32px;
        color: #41b8dc;
        font-weight: 700;
        margin-bottom: 12px;
    }

    &__description {
        color: #000000;
        margin-bottom: 15px;
        font-size: 15px;
    }

    &__btn {
        font-size: 20px;
        width: 136px;
        height: 50px;
        font-weight: 600;
    }
}
</style>
